import {globals} from "../globals";

const OPENBANKING_ENDPOINT = 'https://testapi.openbanking.or.kr'
const CLIENT_ID = 'nfXIxg20G9sAUngGLYEA8hSurqI0pgVD5IedxbWU'
const CALLBACK_URI = `${globals.appDomain}/setting/openbankingauth`

export {
    OPENBANKING_ENDPOINT, CLIENT_ID, CALLBACK_URI
}
